const initialState = {
  selectedMonth: '',
};

export default initialState;
